import React, { useState, useEffect } from 'react';
import HelpIcon from '@mui/icons-material/Help';
import Button from '@mui/material/Button';


const LoupeHelpButton = (props) => {

    const openHelpDrawbackHandler = props.openHelpDrawbackHandler;
    const topic = props.topic;


    const availableHelpTopics = ["/", "/activities-here"];
    
    
        if(availableHelpTopics.includes(topic)) 
        {
            return(
                <Button onClick={() => openHelpDrawbackHandler(topic)}>
                    <HelpIcon />
                </Button>
            )
        } else {
            return (<></>)
        }
    

}
export default LoupeHelpButton;